const DispatchPlanning = {

    // FIELDS
    "dispatch_date": "Dispatch Date",
    "driver": "Driver",
    "vehicle": "Vehicle",
    "route": "Route",
    "dispatch_advice": "Dispatch Advice",
    "date": "Date",
    "delivery_date": "Delivery Date",
    "dispatch_advice_id": "Dispatch Advice ID",
    "customer": "Customer",
    "action": "Action",
    "search": "Search",

    // PAGE HEADER
    "dispatch_planning": "Dispatch Planning",

    // ERROR
    "error_dispatch_date": "Choose Date",
    "error_driver": "Select Driver",
    "error_vehicle": "Select Vehicle",
    "error_route": "Select Route",
    "error_dispatch_advice": "Dispatch advice not found",

    // TABLE HEADER
    "table_planning_id": "PLANNING ID",
    "table_date": "DATE",
    "table_driver": "DRIVER",
    "table_driver_contact": "DRIVER CONTACT",
    "table_vehicle": "VEHICLE",
    "table_regitration_number": 'REGISTRATION NUMBER',
    "table_route": 'ROUTE',
}

export default DispatchPlanning;